import {ChangeDetectionStrategy, Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {OrganizationSelectors} from '@store/organization/organization.selectors';

@Component({
  selector: 'px-root',
  template: '<router-outlet/>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule]
})
export class AppComponent {
  public readonly organizationSelector = OrganizationSelectors.Auth;
}
